module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '广告名称',
      overflow: false,
      width: 200,
      format: (row) => {
        const { name, id } = row;
        const { channel_interface, advertiser_id } = s.table_params;
        const h = s.$createElement;
        const ele = h('el-link', {
          class: 'ml-5',
          props: {
            type: 'primary',
            underline: false,
          },
          on: {
            click: () => {
              const params = {
                channel_interface,
                advertiser_id,
                campaign_id: id,
              };
              s.$router.push({
                name: 'CreativeManage',
                params,
              });
            },
          },
        },
        name);
        return ele;
      },
    },
    {
      name: '广告ID',
      value: 'id',
    },
    {
      name: '状态',
      format: ({ status }) => {
        return s.enum_map.status[status] || '-';
      },
    },
    {
      name: '投放平台',
      format: ({ delivery_platform_type }) => {
        return s.enum_map.delivery_platform_type[delivery_platform_type];
      },
    },
    {
      name: '投放内容',
      format: ({ delivery_content }) => {
        const { id, name } = delivery_content || {};
        return delivery_content ? `${name}（${id}）` : '-';
      },
    },
    {
      name: '广告版位',
      format: ({ site_set_type = 1, site_sets = [] }) => {
        return site_set_type === 1 ? '自动版位' : site_sets.map(site_set => s.enum_map.site_sets[site_set]).join('、');
      },
    },
    {
      name: '投放日期',
      format: ({ begin_date, end_date }) => {
        const is_valid = begin_date && end_date;
        return is_valid ? `${begin_date} - ${end_date}` : '长期投放';
      },
    },
    {
      name: '日预算',
      format: ({ daily_budget_type, daily_budget }) => {
        return daily_budget_type === 'BUDGET_MODE_INFINITE' ? '不限' : `${daily_budget / 100} 元`;
      },
    },
    {
      name: '操作',
      width: 120,
      format: (row) => {
        const { status } = row;
        const is_enable = status === 'ENABLE';
        const h = s.$createElement;
        const ele = h('div', null, [
          h('el-link', {
            props: {
              type: 'primary',
              underline: false,
            },
            on: {
              click: () => {
                s.onEdit(row);
              },
            },
          },
          '编辑'),
          h('el-link', {
            class: 'ml-5',
            props: {
              type: is_enable ? 'info' : 'success',
              underline: false,
            },
            on: {
              click: () => {
                s.onSwitch(row);
              },
            },
          },
          is_enable ? '关闭' : '开启'),
          h('el-link', {
            class: 'ml-5',
            props: {
              type: 'danger',
              underline: false,
            },
            on: {
              click: () => {
                const { id } = row;
                s.onDel([id]);
              },
            },
          },
          '删除'),
        ]);

        return ele;
      },
    },
  ];
};
